var version = {
    "name":      "dativery",
    "buildDateCode": "20260615-064111",
    "buildDate": "Mon Jun 15 2026 06:41:11 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260615-064111",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;